// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"2c83249b","388":"6dc5dc02","796":"6aebf55d"}[chunkId] + ".chunk.css";
};